import { useQuery } from 'react-query';
import { useApi } from '../../core/api/api.context';
import { QueryKeys } from '../../core/queries/query-keys.constants';

export function useQueryListSettingsSchemas() {
  const api = useApi();

  return useQuery([QueryKeys.SETTINGS_SCHEMAS], async () => {
    return await api.settingsSchemasController.getAllSettingsSchemas();
  });
}
